import { useRouter } from "vue-router"

const router = useRouter()

export function useMaintenance() {
  function setMaintenance(value) {
    if (value) {
      router.push({ name: "maintenance" })
    }
  }
  return {
    setMaintenance,
  }
}
